import { useQuery } from '@tanstack/react-query';

import { QUERY_KEY } from '~common';
import { getRequest } from '~services/client.service';
import { UseQueryOptionsType, VenueDetail } from '~types';
import { toastError } from '~utils';

type IDetailVenueParams = {
  managedGroupId?: string | null;
  id?: string;
};

export const useQueryDetailVenue = (
  reqParams: IDetailVenueParams,
  options?: UseQueryOptionsType<IDetailVenueParams, VenueDetail>,
) => {
  const getDetailVenue = (): Promise<VenueDetail> =>
    getRequest({ path: 'api/admin/venue/detail', params: reqParams }).then(
      (res) => res,
    );

  return useQuery([QUERY_KEY.GET_VENUE_DETAIL, reqParams], getDetailVenue, {
    ...options,
    onError(err) {
      toastError({
        error: err,
        axiosMessage: 'Something went wrong when getting venue detail',
      });
    },
  });
};
